import React, { useRef, useEffect } from 'react';
import { GoogleMap, OverlayView } from '@react-google-maps/api';
import { Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';

const containerStyle = {
  width: '100%',
  height: '100%',
};

// マーカー吹き出しコンポーネント
function MarkerBalloon({ marker, onClick }) {
  return (
    <OverlayView
      position={{ lat: marker.lat, lng: marker.lng }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick(marker);
        }}
        style={{
          transform: "translate(-50%, -100%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          cursor: "pointer"
        }}
      >
        {/* バルーン */}
        <div style={{
          background: "#fff",
          padding: "4px 8px",
          borderRadius: 6,
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          fontSize: 12,
          maxWidth: 200,
          width: "max-content",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word"
        }}>
          <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>{marker.name}</Typography>
        </div>
        {/* 三角 */}
        <div style={{
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "6px solid white",
          marginTop: "-1px"
        }}/>
        {/* 丸アイコン */}
        <div style={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          background: '#EA4335',
          border: "2px solid white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.4)"
        }}>
          <PlaceIcon style={{ color: "white", fontSize: 22 }} />
        </div>
      </div>
    </OverlayView>
  );
}

// マーカー表示用のGoogleMapコンポーネント
export default function MarkerViewMap({
  apiKey,
  markers = [],
  defaultCenter = { lat: 36.0, lng: 138.0 },
  onEditMarkerClick, 
}) {
  const mapRef = useRef(null);

  // マーカーが変更された
  useEffect(() => {
    // マーカーに合わせてズームとセンターを調整
    fitMapToMarkers();
  }, [markers]);

  // マーカーに合わせてズームとセンターを調整する関数（初回以外も呼べるように）
  const fitMapToMarkers = () => {
    // 地図APIロード前はやらない
    if (!mapRef.current || !window.google) return;
    // マーカーがない場合はやらない
    if (markers.length === 0) return;
    // マーカーが1件だけの場合はその位置にズーム
    if (markers.length === 1) {
      mapRef.current.setCenter({ lat: markers[0].lat, lng: markers[0].lng });
      mapRef.current.setZoom(14);
    } else {
      // 複数マーカーがある場合は全てのマーカーが見えるようにズームとセンターを調整
      const bounds = new window.google.maps.LatLngBounds();
      markers.forEach(m => bounds.extend({ lat: m.lat, lng: m.lng }));
      mapRef.current.fitBounds(bounds, 50); // 50pxの余白をつける
    }
  }

  // 地図ロード
  const handleMapLoad = (map)=>{
    mapRef.current = map

    // マーカーに合わせてズームとセンターを調整
    fitMapToMarkers();
  }

  // 地図クリック
  const handleMapClick = e => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
  };

  // 地図表示
  return (
    <>
      {/* 地図 */}
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={defaultCenter}
        zoom={12}
        onLoad={handleMapLoad}
        onClick={handleMapClick}
        options={{
          clickableIcons: true,
          mapTypeControl: true,
          streetViewControl: true,
          fullscreenControl: true,
        }}
      >
        {/* マーカー */}
        {markers.map((marker) => (
          <MarkerBalloon
            key={marker.id}
            marker={marker}
            onClick={onEditMarkerClick}
          />
        ))}
      </GoogleMap>
    </>
  );
}